import { Component, ErrorInfo } from 'react'
import * as Sentry from '@sentry/react'
import { Text, theme } from 'yolda-web-ui'
import { Trans } from 'react-i18next'
import { getEnv } from '../../../config/env'
import { StyledErrorBoundary } from './ErrorBoundary.style'

class ErrorBoundary extends Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError() {
    return { error: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    getEnv() === 'production' &&
      Sentry.withScope((scope: any) => {
        scope.setExtras(errorInfo)
        const eventId = Sentry.captureException(error)
        this.setState({ eventId, errorInfo })
      })

    this.setState({ error: true })
  }

  render() {
    if (this.state.error) {
      return (
        <StyledErrorBoundary>
          <section>
            <Text as="h1" mb={theme.spacing.medium}>
              <Trans i18nKey="errorBoundary.title" />
            </Text>
            <Text as="p" mb={theme.spacing.default}>
              <Trans i18nKey="errorBoundary.desc" />
            </Text>
            <Text as="p" mb={theme.spacing.medium}>
              <Trans i18nKey="errorBoundary.desc2" />
            </Text>
            <a href="/">
              <Trans i18nKey="errorBoundary.button" />
            </a>
          </section>
        </StyledErrorBoundary>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
